import { createAction } from 'redux-actions';

export const clearGuestVisits = createAction('CLEAR_GUEST_VISITS');

export const guestVisitsOnChangePage = createAction(
  'GUEST_VISITS_ON_CHANGE_PAGE'
);

export const guestVisitsOnChangeOrder = createAction(
  'GUEST_VISITS_ON_CHANGE_ORDER'
);

export const guestVisitsOnChangeLimit = createAction(
  'GUEST_VISITS_ON_CHANGE_Limit'
);
